import Vue from "vue";
import Router from "vue-router";
import goTo from "vuetify/es5/services/goto";
import axios from "axios";
import Swal from "sweetalert2";
//import store from "./store/store";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  // This is for the scroll top when click on any router link
  scrollBehavior: (to, from, savedPosition) => {
    let scrollTo = 0;

    if (to.hash) {
      scrollTo = to.hash;
    } else if (savedPosition) {
      scrollTo = savedPosition.y;
    }

    return goTo(scrollTo);
  },
  // This is for the scroll top when click on any router link
  routes: [
    {
      path: "/",
      redirect: "/authentication/login",
      component: () => import("@/layouts/blank-layout/Blanklayout"),
      children: [
        // Application
        {
          name: "Login",
          path: "/authentication/login",
          component: () => import("@/views/authentication/Login"),
          //meta: { guest: true },
        },

        {
          name: "Dashboard",
          path: "/",
          redirect: "/authentication/login",
          component: () => import("@/layouts/full-layout/Layout"),
          children:
            [
              {
                name: "Carriers",
                path: "carrier",
                component: () => import("@/views/apps/pages/carrier"),
                meta: { requiresAuth: true },
              },
              {
                name: "Rate Management",
                path: "rates_management",
                component: () => import("@/views/apps/pages/rates_management"),
                meta: { requiresAuth: true },
              },
              {
                name: "Customers",
                path: "customers",
                component: () => import("@/views/apps/pages/customers"),
                meta: { requiresAuth: true },
              },
              {
                name: "Business Profile",
                path: "businessprofile",
                component: () => import("@/views/apps/pages/businessprofile"),
                meta: { requiresAuth: true },
              },
              {
                name: "Sites",
                path: "sites",
                component: () => import("@/views/apps/pages/sites"),
                meta: { requiresAuth: true },
              },
              {
                name: "Sites Detail",
                path: "/sitesdetail/:id",
                component: () => import("@/views/apps/pages/sitesdetail"),
                meta: { requiresAuth: true },
              },
              {
                name: "Sites Edit",
                path: "/sitesedit/:id",
                component: () => import("@/views/apps/pages/sitesedit"),
                meta: { requiresAuth: true },
              },
              {
                name: "Carrier Contracts & Origins",
                path: "carrier_contracts_origins",
                component: () => import("@/views/apps/pages/carrier_contracts_origins"),
                meta: { requiresAuth: true },
              },
              {
                name: "Dashboard",
                path: "dashboard",
                component: () => import("@/views/apps/pages/dashboard"),
                meta: { requiresAuth: true },
              },
              {
                name: "Carrier Detail",
                path: "/carrierdetail/:id",
                component: () => import("@/views/apps/pages/carrierdetail"),
                meta: { requiresAuth: true },
              },
              {
                name: "Master Equivalences",
                path: "/master_equivalences",
                component: () => import("@/views/apps/pages/master_equivalences"),
                meta: { requiresAuth: true },
              },
              {
                name: "Carrier Specific Charges",
                path: "/carriers/carrier_specific_charges",
                component: () => import("@/views/apps/pages/carriers/carrier_specific_charges"),
                meta: { requiresAuth: true },
              },
              {
                name: "Purolator Tax Rates",
                path: "/purolator_tax_rates",
                component: () => import("@/views/apps/pages/purolator_tax_rates"),
                meta: { requiresAuth: true },
              },
              {
                name: "Negative Margin Prevention",
                path: "/negative_margin_prevention",
                component: () => import("@/views/apps/pages/negative_margin_prevention"),
                meta: { requiresAuth: true },
              },
              {
                name: "Carrier Service Equivalency",
                path: "carriers/carrier_service_equivalency",
                component: () => import("@/views/apps/pages/carriers/carrier_service_equivalency"),
                meta: { requiresAuth: true },
              },
              {
                name: "Carrier Surcharge Equivalency",
                path: "carriers/carrier_surcharge_equivalency",
                component: () => import("@/views/apps/pages/carriers/carrier_surcharge_equivalency"),
                meta: { requiresAuth: true },
              },
              {
                name: "Customer Reset Password",
                path: "/customer/password/reset_token/:password_reset_token",
                component: () => import("@/views/apps/pages/customer_reset_password"),
                meta: { requiresAuth: true },
              },
              {
                name: "Customer Detail",
                path: "/customerdetail/:id",
                component: () => import("@/views/apps/pages/customerdetail"),
                meta: { requiresAuth: true },
              },
              {
                name: "Customer Edit",
                path: "/customeredit/:id",
                component: () => import("@/views/apps/pages/customeredit"),
                meta: { requiresAuth: true },
              },
              {
                name: "Rates Management Detail",
                path: "/rates_managementdetail/:id",
                component: () => import("@/views/apps/pages/rates_managementdetail"),
                meta: { requiresAuth: true },
              },
              {
                name: "Rates Management Edit",
                path: "/rates_managementedit/:id",
                component: () => import("@/views/apps/pages/rates_managementedit"),
                meta: { requiresAuth: true },
              },
              {
                name: "Carrier Tariffs",
                path: "carriers/carrier_tariffs",
                component: () => import("@/views/apps/pages/carriers/carrier_tariffs"),
                meta: { requiresAuth: true },
              },
              {
                name: "Carrier Tariff Detail",
                path: "carriers/carrier_tariffdetail/:id",
                component: () => import("@/views/apps/pages/carriers/carrier_tariffdetail"),
                meta: { requiresAuth: true },
              },
              {
                name: "Carrier Bills",
                path: "carriers/invoices",
                component: () => import("@/views/apps/pages/carriers/invoices"),
                meta: { requiresAuth: true },
              },
              {
                name: "Carrier Bills Detail",
                path: "carriers/carrierbillsdetail/:id",
                component: () => import("@/views/apps/pages/carriers/carrierbillsdetail"),
                meta: { requiresAuth: true },
              },
              {
                name: "Queue",
                path: "queue",
                component: () => import("@/views/apps/pages/queue"),
                meta: { requiresAuth: true },
              },
              {
                name: "Users",
                path: "users",
                component: () => import("@/views/apps/pages/users"),
                meta: { requiresAuth: true },
              },
              {
                name: "Users Detail",
                path: "/usersdetail/:id",
                component: () => import("@/views/apps/pages/usersdetail"),
                meta: { requiresAuth: true },
              },
              {
                name: "Users Edit",
                path: "/usersedit/:id",
                component: () => import("@/views/apps/pages/usersedit"),
                meta: { requiresAuth: true },
              },
              {
                name: "Invoice",
                path: "invoice",
                component: () => import("@/views/apps/pages/invoice"),
                meta: { requiresAuth: true },
              },
              {
                name: "2Ship API",
                path: "2ship_api",
                component: () => import("@/views/apps/pages/2ship_api"),
                meta: { requiresAuth: true },
              },
              {
                name: "FedEx API",
                path: "fedex_api",
                component: () => import("@/views/apps/pages/fedex_api"),
                meta: { requiresAuth: true },
              },
              {
                name: "Proposal",
                path: "analysis/proposal/:id",
                component: () => import("@/views/apps/pages/analysis/proposal"),
                meta: { requiresAuth: true },
              },
              {
                name: "Proposal ID",
                path: "analysis/proposal ",
                component: () => import("@/views/apps/pages/analysis/proposal "),
                meta: { requiresAuth: true },
              },
              {
                name: "Ratecard Proposal",
                path: "analysis/ratecard_proposal",
                component: () => import("@/views/apps/pages/analysis/ratecard_proposal"),
                meta: { requiresAuth: true },
              },
              {
                name: "Ratecard Report",
                path: "analysis/ratecard_report",
                component: () => import("@/views/apps/pages/analysis/ratecard_report"),
                meta: { requiresAuth: true },
              },
              {
                name: "Rates Report",
                path: "analysis/ratesreport/:id",
                component: () => import("@/views/apps/pages/analysis/ratesreport"),
                meta: { requiresAuth: true },
              },
              {
                name: "Analyze Invoice",
                path: "analysis/analyze_invoice/:id",
                component: () => import("@/views/apps/pages/analysis/analyze_invoice"),
                meta: { requiresAuth: true },
              },
              {
                name: "Ship Customer Location",
                path: "analysis/ship_customer_location",
                component: () => import("@/views/apps/pages/analysis/ship_customer_location"),
                meta: { requiresAuth: true },
              },
              {
                name: "Switching Analysis",
                path: "analysis/switching_analysis",
                component: () => import("@/views/apps/pages/analysis/switching_analysis"),
                meta: { requiresAuth: true },
              },
              {
                name: "Proposal",
                path: "analysis/proposals/:id",
                component: () => import("@/views/apps/pages/analysis/proposals"),
                meta: { requiresAuth: true },
              },
              {
                name: "Client Proposal Materials",
                path: "analysis/client_proposal_materials",
                component: () => import("@/views/apps/pages/analysis/client_proposal_materials"),
                meta: { requiresAuth: true },
              },
              {
                name: "Integrations",
                path: "analysis/integrations",
                component: () => import("@/views/apps/pages/analysis/integrations"),
                meta: { requiresAuth: true },
              },
              {
                name: "GeneratedProposal",
                path: "analysis/generated-proposal",
                component: () => import("@/views/apps/pages/analysis/generated-proposal"),
                meta: { requiresAuth: true },
              },
              {
                name: "Billing Work flow",
                path: "billing/billingworkflow",
                component: () => import("@/views/apps/pages/billing/billingworkflow"),
                meta: { requiresAuth: true },
              },
              {
                name: "Billing Work flow Detail",
                path: "billing/billingworkflowdetail/:id",
                component: () => import("@/views/apps/pages/billing/billingworkflowdetail"),
                meta: { requiresAuth: true },
              },
              {
                name: "Batch Reports",
                path: "billing/batchreports",
                component: () => import("@/views/apps/pages/billing/batchreports"),
                meta: { requiresAuth: true },
              },
              {
                name: "Customer Bills",
                path: "billing/customerbills",
                component: () => import("@/views/apps/pages/billing/customerbills"),
                meta: { requiresAuth: true },
              },
              {
                name: "SimpleCustomerBilling",
                path: "billing/simplecustomerbilling",
                component: () => import("@/views/apps/pages/billing/simplecustomerbilling"),
                meta: { requiresAuth: true },
              },
              {
                name: "ComplexCustomerBilling",
                path: "billing/complexcustomerbilling",
                component: () => import("@/views/apps/pages/billing/complexcustomerbilling"),
                meta: { requiresAuth: true },
              },
              {
                name: "Complex Billing Detail",
                path: "billing/complexbillingdetail/:id",
                component: () => import("@/views/apps/pages/billing/complexbillingdetail"),
                meta: { requiresAuth: true },
              },
              {
                name: "Billing",
                path: "billing",
                component: () => import("@/views/apps/pages/billing"),
                meta: { requiresAuth: true },
              },
              {
                name: "Billing Detail",
                path: "billingdetail/:id",
                component: () => import("@/views/apps/pages/billingdetail"),
                meta: { requiresAuth: true },
              },
              {
                name: "Add Customers to FedEx EDI",
                path: "addcustomerfedex",
                component: () => import("@/views/apps/pages/tools/addcustomerfedex"),
                meta: { requiresAuth: true },
              },
              {
                name: "Customer",
                path: "customer",
                component: () => import("@/views/apps/pages/customer"),
                meta: { requiresAuth: true },
              },
              {
                name: "Event Log",
                path: "event_log",
                component: () => import("@/views/apps/pages/user_log"),
                meta: { requiresAuth: true },

              },
              {
                name: "Add File",
                path: "add_file",
                component: () => import("@/views/apps/pages/add_file"),
                meta: { requiresAuth: true },
              },
              {
                name: "Carrier Login",
                path: "carrier_login",
                component: () => import("@/views/apps/pages/carrier_login"),
                meta: { requiresAuth: true },
              },
              {
                name: "Settings",
                path: "settings",
                component: () => import("@/views/apps/pages/settings"),
                meta: { requiresAuth: true },
              },
              {
                name: "Packages",
                path: "packages",
                component: () => import("@/views/apps/pages/packages"),
                meta: { requiresAuth: true },
              },
              {
                name: "Your Profile",
                path: "your_profile",
                component: () => import("@/views/apps/pages/your_profile"),
                meta: { requiresAuth: true },
              },
              {
                name: "Test",
                path: "test",
                component: () => import("@/views/apps/pages/test"),
                meta: { requiresAuth: true },
              },
              {
              name: "Search",
                path: "search",
                component: () => import("@/views/apps/pages/search"),
                meta: { requiresAuth: true },
              },
              {
                name: "Countries",
                path: "countries",
                component: () => import("@/views/apps/pages/countries"),
                meta: { requiresAuth: true },
              },
              {
                name: "Changelog",
                path: "changelog",
                component: () => import("@/views/apps/pages/changelog"),
                meta: { requiresAuth: true },
              },
            ],

        },
      ],
    },
    {
      path: "/authentication",
      component: () => import("@/layouts/blank-layout/Blanklayout"),
      children: [
        {
          name: "Forget Password",
          path: "forgetpswd",
          component: () => import("@/views/authentication/forgetpswd"),
        },
        {
          name: "Reset Password",
          path: "resetpswd/:id",
          component: () => import("@/views/authentication/resetpswd"),
        },
        {
          name: "Test Login",
          path: "testlogin",
          component: () => import("@/views/authentication/testlogin"),
          //meta: { requiresAuth: true },
        },
        {
          name: "Test Login",
          path: "teststore",
          component: () => import("@/views/authentication/teststore"),
          //meta: { requiresAuth: true },
        },
        {
          name: "Logout",
          path: "logout",
          component: () => import("@/views/authentication/Logout"),
          meta: { requiresAuth: true },
        },
        {
          name: "BoxedLogin",
          path: "boxedlogin",
          component: () => import("@/views/authentication/BoxedLogin"),
        },
        {
          name: "FullLogin",
          path: "fulllogin",
          component: () => import("@/views/authentication/FullLogin"),
        },
        {
          name: "BoxedRegister",
          path: "boxedregister",
          component: () => import("@/views/authentication/BoxedRegister"),
        },
        {
          name: "FullRegister",
          path: "fullregister",
          component: () => import("@/views/authentication/FullRegister"),
        },
        {
          name: "Error",
          path: "error",
          component: () => import("@/views/authentication/Error"),
        },
      ],
    },
    {
      path: "*",
      component: () => import("@/views/authentication/Error"),
    },
  ],
});

import NProgress from "nprogress";

router.beforeResolve((to, from, next) => {
  // If this isn't an initial page load.
  if (to.name) {
    // Start the route progress bar.
    NProgress.start(800);
  }
  next();
});

router.afterEach(() => {
  // Complete the animation of the route progress bar.
  NProgress.done();
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    let isAuthenticated = JSON.parse(localStorage.getItem("isAuthenticated"));
    console.log(isAuthenticated);
    console.log("test auth------->");

    if (isAuthenticated) {
      next();
      return;
    }
    next("/authentication/login");
  } else {
    next();
  }
});

// Block direct URL access to disabled navigation modules.
// For each URL pattern, list the pr_menu `link` keys that grant access.
// MORE SPECIFIC patterns must come first — .find() returns the first match.
// Matching is exact against normalized active_menu_paths (no prefix fallback),
// so children can be disabled independently of their parent.
const normPath = (p) => (p || "").toString().replace(/^\/+|\/+$/g, "").toLowerCase();

const GUARDED_MODULES = [
  // ── Dashboard ──
  { match: /^\/dashboard(\/|$)/, menu: ["dashboard"] },

  // ── Batches children (specific first) ──
  { match: /^\/billing\/customerbills/, menu: ["billing/customerbills"] },
  { match: /^\/billing\/batchreports/, menu: ["billing/batchreports"] },
  { match: /^\/billing\/billingworkflow/, menu: ["billing/billingworkflow"] },
  // ── Batches parent ──
  { match: /^\/billing(\/|$)/, menu: ["billing"] },
  { match: /^\/billingdetail/, menu: ["billing"] },

  // ── Integrations (/analysis/integrations must match before generic /analysis) ──
  { match: /^\/analysis\/integrations/, menu: ["analysis/integrations", "integrations"] },

  // ── Analysis ──
  // pr_menu row for "Analysis" uses link="/analysis/ratecard_proposal" (see navigation_modules.sql),
  // so match that key in addition to the generic "analysis".
  { match: /^\/analysis(\/|$)/, menu: ["analysis", "analysis/ratecard_proposal"] },

  // ── Rates Management ──
  { match: /^\/rates_management/, menu: ["rates_management"] },

  // ── Customers ──
  { match: /^\/customers(\/|$)/, menu: ["customers"] },
  { match: /^\/customerdetail/, menu: ["customers"] },
  { match: /^\/customeredit/, menu: ["customers"] },

  // ── Queue ──
  { match: /^\/queue(\/|$)/, menu: ["queue"] },

  // ── Settings children (specific first) ──
  { match: /^\/event_log/, menu: ["event_log"] },
  { match: /^\/businessprofile/, menu: ["businessprofile"] },
  { match: /^\/carrier_contracts_origins/, menu: ["carrier_contracts_origins"] },
  // ── Settings parent ──
  { match: /^\/settings(\/|$)/, menu: ["settings"] },

  // ── Carriers children (specific first) ──
  { match: /^\/carriers\/carrier_tariff/, menu: ["carriers/carrier_tariffs"] },
  { match: /^\/carriers\/carrier_service_equivalency/, menu: ["carriers/carrier_service_equivalency", "master_equivalences"] },
  { match: /^\/carriers\/carrier_surcharge_equivalency/, menu: ["carriers/carrier_surcharge_equivalency", "master_equivalences"] },
  { match: /^\/carriers\/carrier_specific_charges/, menu: ["carriers/carrier_specific_charges"] },
  { match: /^\/purolator_tax_rates/, menu: ["purolator_tax_rates"] },
  { match: /^\/master_equivalences/, menu: ["master_equivalences"] },
  { match: /^\/carriers\/invoices/, menu: ["carriers/invoices"] },
  { match: /^\/carriers\/carrierbillsdetail/, menu: ["carriers/invoices"] },
  // ── Carriers parent ──
  { match: /^\/carrierdetail/, menu: ["carrier"] },
  { match: /^\/carrier(\/|$)/, menu: ["carrier"] },

  // ── Integrations ──
  { match: /^\/fedex_api/, menu: ["fedex_api", "analysis/integrations"] },
  { match: /^\/2ship_api/, menu: ["2ship_api", "analysis/integrations"] },

  // ── Shipment Search ──
  { match: /^\/search/, menu: ["search"] },
];

// Session-scoped cache of the getmenuitems fetch. The router guard awaits this
// on the first guarded navigation so admin-side Active/Inactive toggles take
// effect immediately — without the cache the guard reads stale localStorage
// from a prior session and only blocks on the second navigation.
let menuPathsFetch = null;

function fetchActiveMenuPaths() {
  if (menuPathsFetch) return menuPathsFetch;

  const users = JSON.parse(localStorage.getItem("users") || "null");
  if (!users) {
    // Not logged in — skip the fetch; guard will fall back to whatever localStorage has.
    return Promise.resolve(null);
  }

  menuPathsFetch = axios
    .post(Vue.prototype.$apiurl + "api/web/site/getmenuitems", { user: users })
    .then((res) => {
      const paths = [];
      const walk = (arr) => {
        if (!Array.isArray(arr)) return;
        arr.forEach((it) => {
          if (it && it.to) paths.push(it.to);
          if (it && it.children) walk(it.children);
        });
      };
      walk(res && res.data && res.data.data);
      localStorage.setItem("active_menu_paths", JSON.stringify(paths));
      return paths;
    })
    .catch(() => {
      // On failure, let the guard fall through to localStorage so a flaky network
      // doesn't lock everybody out.
      menuPathsFetch = null;
      return null;
    });

  return menuPathsFetch;
}

router.beforeEach(async (to, from, next) => {
  const guarded = GUARDED_MODULES.find((g) => g.match.test(to.path));
  if (!guarded) return next();

  // Returns the fresh path list on success, null on "no authoritative answer"
  // (unauthenticated or network failure). An empty array IS authoritative — it
  // means the backend has disabled every guarded module for this user.
  const fetched = await fetchActiveMenuPaths();

  if (fetched === null) {
    // No authoritative answer — fall through. Auth interceptor will handle 401/403.
    return next();
  }

  const activeSet = new Set(fetched.map(normPath));
  const isActive = guarded.menu.some((key) => activeSet.has(normPath(key)));
  if (!isActive) {
    // No redirect — show an access-denied alert and cancel the navigation so the
    // user stays where they were. On first-load (no prior route), next(false) leaves
    // the page blank behind the modal, which is the expected outcome for a directly
    // typed denied URL.
    Swal.fire({
      icon: "warning",
      title: "Access Denied",
      text: "You don't have access to this section.",
    });
    return next(false);
  }
  next();
});

// Watch for admin-side Active/Inactive toggles while the user is already logged in
// and viewing a page. Without this, guard changes only take effect on the next
// navigation — meaning the user can keep interacting with a module that was just
// disabled. Polls every 15 seconds — slower than auth-check (5s) because menu
// changes are admin-driven and infrequent, so we trade a little staleness for
// 1/3 the request load.
let menuRecheckInterval = null;
let menuRecheckAlertShown = false;
function startMenuRecheck() {
  if (menuRecheckInterval) return;
  menuRecheckInterval = setInterval(async () => {
    if (!localStorage.getItem("tokens")) return;
    // Bust the per-session cache so we get fresh data, not the value captured on first load.
    menuPathsFetch = null;
    const fetched = await fetchActiveMenuPaths();
    if (fetched === null) return; // network failure or unauthenticated — ignore

    const currentPath = router.currentRoute.path;
    const guarded = GUARDED_MODULES.find((g) => g.match.test(currentPath));
    if (!guarded) {
      menuRecheckAlertShown = false;
      return;
    }

    const activeSet = new Set(fetched.map(normPath));
    const isActive = guarded.menu.some((key) => activeSet.has(normPath(key)));
    if (isActive) {
      menuRecheckAlertShown = false;
      return;
    }

    // Don't spam — one alert per revocation event. The flag resets when the user
    // navigates away (handled above) or the module is re-enabled.
    if (menuRecheckAlertShown) return;
    menuRecheckAlertShown = true;

    Swal.fire({
      icon: "warning",
      title: "Access Denied",
      text: "Your access to this section has been revoked. You will be moved to an available section.",
    });

    // Push the user off the now-disabled page. Prefer the first remaining active
    // path so they land somewhere usable; if nothing's active, log them out.
    const firstActive = fetched.find((p) => normPath(p) !== "");
    if (firstActive) {
      router.replace("/" + normPath(firstActive)).catch(() => {});
    } else {
      window.location.href = "/authentication/logout";
    }
  }, 15000);
}
startMenuRecheck();

// router.beforeEach((to, from, next) => {
//   if (to.matched.some((record) => record.meta.guest)) {
//     if (store.getters.isAuthenticated) {
//       next("/apps/pages/dashboard");
//       return;
//     }
//     next();
//   } else {
//     next();
//   }
// });

export default router;
